import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { commonActions } from '../../store/actions'

const Zip = (props) => {
  const [state, setState] = useState({
    keyword: '',
    confmKey: 'U01TX0FVVEgyMDE5MDcwOTEzMzYzMzEwODg2ODE=',
    currentPage: 1,
  })
  const [nextBtn, setNextBtn] = useState(false)
  const [preBtn, setPreBtn] = useState(false)

  useEffect(() => {
    setState({ ...state, keyword: '' })
    props.resetZipCode()
  }, [])

  useEffect(() => {
    if (state.currentPage === 1) {
      setPreBtn(false)
    } else if (state.currentPage > 1) {
      setPreBtn(true)
    } else {
      setPreBtn(false)
    }
  }, [state.currentPage])

  useEffect(() => {
    if (!props.pageInfo) return

    let left = props.pageInfo?.totalCount / props.pageInfo?.countPerPage - props.pageInfo?.currentPage

    if (left > 0) {
      setNextBtn(true)
    } else {
      setNextBtn(false)
    }
  }, [props.pageInfo])

  const handleChange = (e) => {
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value,
    })
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      searchHandler()
    }
  }

  const searchHandler = () => {
    const params = {
      ...state,
      currentPage: 1,
    }
    props.getZipAddress(params)
    setState({ ...state, currentPage: params.currentPage })
  }

  const prePage = () => {
    const params = {
      ...state,
      currentPage: state.currentPage - 1,
    }
    props.getZipAddress(params)
    setState({ ...state, currentPage: params.currentPage })
  }

  const nextPage = () => {
    const params = {
      ...state,
      currentPage: state.currentPage + 1,
    }
    props.getZipAddress(params)
    setState({ ...state, currentPage: params.currentPage })
  }

  let style = {
    backgroundColor: 'rgb(0, 0, 0)',
    position: 'fixed',
    inset: '0px',
    opacity: '0.6',
    zIndex: '9998',
  }

  let styleModal = {
    position: 'absolute',
    opacity: '1',
    zIndex: '9999',
    display: 'block',
  }

  let styleInput = {
    width: '30%',
  }

  return (
    <React.Fragment>
      <div style={style}></div>
      <div style={styleModal} className="modal w1120">
        <div className="modal-head">
          <h2>우편번호 검색</h2>
        </div>
        <div className="modal-cont">
          <div className="list-header">
            <input
              title="검색할 주소명"
              type="text"
              className="form-keyword"
              style={styleInput}
              placeholder="주소검색"
              name="keyword"
              value={state.keyword}
              onChange={(e) => handleChange(e)}
              onKeyPress={(e) => handleKeyPress(e)}
            />
            &nbsp;
            <a className="btn-secondary sm" onClick={searchHandler}>
              검색
            </a>
          </div>
          <div className="tbl-wrap">
            <table className="tbl-list">
              <caption>우편번호, 지번,도로명 항목으로 구성</caption>
              <colgroup>
                <col style={{ width: '10%' }} />
                <col style={{ width: '45%' }} />
                <col style={{ width: '45%' }} />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">우편번호</th>
                  <th scope="col">지번</th>
                  <th scope="col">도로명</th>
                </tr>
              </thead>
              <tbody>
                {props.zipAddress.juso ? (
                  props.zipAddress.juso.map((item, index) => (
                    <tr key={index} onClick={() => props.onSelect(item)}>
                      <td className="cell" data-title={'우편번호'}>
                        {item.zipNo}
                      </td>
                      <td className="cell" data-title={'지번'}>
                        {item.jibunAddr}
                      </td>
                      <td className="cell" data-title={'도로명'}>
                        {item.roadAddr}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3}>
                      <div className="nodata">등록된 자료가 없습니다.</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <div className="btn-block center">
              {preBtn && (
                <a className="btn-secondary md" onClick={prePage}>
                  이전
                </a>
              )}
              {nextBtn && (
                <a className="btn-secondary md" onClick={nextPage}>
                  다음
                </a>
              )}
            </div>
          </div>
        </div>
        <button type="button" className="modal-close b-close" onClick={props.onChange}>
          창닫기
        </button>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    zipAddress: state.common,
    pageInfo: state.common.pageInfo,
  }
}

const actionCreators = {
  getZipAddress: commonActions.getZipAddress,
  resetZipCode: commonActions.resetZipCode,
}

export default connect(mapStateToProps, actionCreators)(Zip)
